import { Component, computed, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormControlType, FormGroupComponent } from '@iot-platform/iot-platform-ui';
import { EvalHelper } from '@iot-platform/iot-platform-utils';
import { I4BGridFilterOptions } from '@iot-platform/models/grid-engine';
import { TranslatePipe } from '@ngx-translate/core';
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';
import { get } from 'lodash';
import { AbstractCellFilterComponent } from '../abstract-filter.component';

@Component({
  selector: 'grid-engine-rich-variable-value-cell-filter',
  imports: [FormsModule, MatFormFieldModule, MatSelectModule, MatInputModule, TranslatePipe, MatButtonModule, FormGroupComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './rich-variable-value-cell-filter.component.html'
})
export class RichVariableValueCellFilterComponent extends AbstractCellFilterComponent {
  constructor() {
    super();
    this.fields = computed(() => [
      this.operatorField,
      {
        ...this.searchTermField,
        type: FormControlType.NUMBER
      }
    ]);
  }

  override agInit(params: IFilterParams & { filterOptions: I4BGridFilterOptions[] }): void {
    super.agInit(params);
    this.operators.set([
      { label: I4BGridFilterOptions.EQUALS, value: '===' },
      { label: I4BGridFilterOptions.LESS_THAN, value: '<' },
      { label: I4BGridFilterOptions.GREATER_THAN, value: '>' },
      { label: I4BGridFilterOptions.LESS_THAN_OR_EQUAL, value: '<=' },
      { label: I4BGridFilterOptions.GREATER_THAN_OR_EQUAL, value: '>=' }
    ]);
  }

  handleDoesFilterPass(params: IDoesFilterPassParams): boolean {
    const field = get(this.filterParams, ['colDef', 'filterParams', 'field'], get(this.filterParams, ['colDef', 'field']));
    const value = get(params.data, field, '').toString().toLowerCase();
    return EvalHelper.evaluate<boolean>(`${value}${this.operatorControl?.getRawValue()?.value}${this.lastValue}`);
  }
}
